module.exports = __webpack_public_path__ + "img/tu_27.504ed338.jpg";